<template lang="html">
  <v-dialog
    v-model ="show"
    persistent
    width="300">
    <v-card
      :color="cardColor"
      dark>
      <v-card-text>
        <v-icon v-if="progressValue === 100">mdi-check</v-icon>
        <v-icon v-if="progressValue === Infinity">mdi-close-circle</v-icon>
        <p v-else>Just a sec ..</p>
        <v-progress-linear
          v-model="progressValue"
          :color="barColor"
          class="mb-0"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
    progressValue: Number
  },
  computed: {
    cardColor () {
      const pv = this.progressValue
      return pv === Infinity ? 'error' :
        pv < 100 ? 'secondary' : 'success'
    },
    barColor () {
      return (this.progressValue < 100) ? 'primary' : '#3D8B40'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
